import React from "react";
import TestPromptV2Main from "../test-prompt-v2/TestPromptV2Main";

/**
 * Anything tool for item 2 of the 0823 plan: word-puzzle photo wrap.
 * Production gen-story stays on v1/v2 illustration until this test looks better.
 */
export default function TestWordPuzzlePhotoMain() {
    return (
        <TestPromptV2Main
            defaultPromptVersion="photo"
            pageTitle="Test word-puzzle photo prompt"
            pageSubtitle={
                "Compare current word-puzzle story art with a standalone-like photo wrap. " +
                "Generates a revision only — production gen-story is unchanged. " +
                "Use Test new prompt v2 on the same story to compare the old illustration path."
            }
        />
    );
}
